import { Button, message, Modal } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { CONTRACT_STATUS, RECORD_STATE } from "Constants";
import { createComponentStore, useStoreState } from "easy-peasy";
import React from "react";
import { ContractStoreModel } from "store/models/contracts";

const useContractStore = createComponentStore(ContractStoreModel);

export default function DeleteButton({ record, actions, loading, ...props }) {
  const [contractStore, contractActions] = useContractStore();
  const { abilities } = useStoreState((store) => store.auth);

  return (
    <>
      {record?.state === RECORD_STATE.ACTIVE && (
        <Button
          type="danger"
          disabled={!AuthCheck(abilities, AUTH_ACTIONS.DELETE, "Muhataplar")}
          loading={loading}
          onClick={async () => {
            const contracts = await contractActions.searchHelp({
              partnerId: record.id,
            });

            console.log(contracts);

            if (
              contracts?.some(
                (s) => s.contractStatu == "ACTIVE" && s.state == "ACTIVE"
              )
            ) {
              message.warning(
                "Etkin sözleşmesi olan bir muhatabı silemezsiniz."
              );
              return;
            }

            Modal.confirm({
              title: "Sil",
              content: "Bu muhatabı silmek istediğinize emin misiniz?",
              okText: "Evet",
              cancelText: "İptal",
              onOk: () =>
                actions.remove({ id: record?.id, version: record?.version }),
            });
          }}
        >
          Sil
        </Button>
      )}
      {record?.state === RECORD_STATE.DELETED && (
        <Button
          disabled={
            !AuthCheck(abilities, AUTH_ACTIONS.RESTORE_ARCHIVE, "Muhataplar")
          }
          onClick={() =>
            actions.restore({ id: record.id, version: record.version })
          }
        >
          Arşivden Geri Al
        </Button>
      )}
    </>
  );
}
